module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/high-capacity-transport-elite.40959d9f.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/high-capacity-transport-elite.png
// module id = 3715
// module chunks = 11